import axios from '../../utils/axios';

/**
 * A partner's relationship manager: one user of its direct parent partner,
 * chosen by that parent's admins. Backed by UPP `/partners/:id/relationship-manager`.
 * Response shape: { partner, relationship_manager: user | null, relationship_manager_assigned_at }
 */
export const getPartnerRelationshipManager = async (partnerId) => {
  const response = await axios.get(`/partners/${partnerId}/relationship-manager`);
  return response.data;
};

/**
 * @param {string} partnerId - the child partner
 * @param {string|null} userId - a user of the parent partner, or null to remove
 */
export const assignPartnerRelationshipManager = async (partnerId, userId) => {
  const response = await axios.put(`/partners/${partnerId}/relationship-manager`, {
    userId: userId || null,
  });
  return response.data;
};
